import * as React from 'react';
import Typography from '@mui/material/Typography';
import { CardMedia, Grid, Button, Box, useMediaQuery, useTheme, Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';

// Dummy imports for icons (replace with your own images or icons)
import IMG1 from '../../../assets/Landing/s1.png';
import IMG2 from '../../../assets/Landing/s2.png';
import IMG3 from '../../../assets/Landing/s3.png';
import IMG4 from '../../../assets/Landing/s4.png';
import IMG5 from '../../../assets/Landing/s1.png';
import IMG6 from '../../../assets/Landing/s2.png';

export default function IndustriesCard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.between('340','sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', '740'));
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('340'));

  return (
    <Box
      sx={{
        height: 'auto',
        backgroundColor: '#f1f1f1',
        position: 'relative',
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingTop: '50px',
        [theme.breakpoints.up('md')]: {
          paddingLeft: '100px',
          paddingRight: '100px',
        }
      }}
    >
      <Typography
        variant="h3"
        sx={{
          color: '#001f3f',
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: 5,
          textTransform: 'uppercase',
          fontSize: isMobile ? '35px' : isExtraSmall ? '27px' : '50px',
        }}
      >
        Our{' '}
        <span style={{ WebkitTextStroke: '1px #001f3f', color: 'transparent' }}>
          Services
        </span>
      </Typography>

      <Box sx={{ width: '90%' }}>
        <Grid container rowSpacing={5} columnSpacing={{ xs: 1, sm: 2, md: 5 }}>
          {/* Card 1: Online Bookkeeping Services */}
          <Grid item xs={12} sm={6}>
            <Card  sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG1} // You can replace with any image
                    alt="Online Bookkeeping"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      Online Bookkeeping Services
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Stay on top of your financials with our customized bookkeeping solutions. We handle accounts receivable, payable, reconciliations, and more, using cloud-based tools like Xero and QuickBooks.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Card 2: ICT Services */}
          <Grid item xs={12} sm={6}>
            <Card  sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG2} // You can replace with any image
                    alt="ICT Services"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      ICT Services
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Transform your technology landscape with our tailored ICT solutions, offering software development, data analytics, automation, and ERP support to drive digital transformation.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Card 3: Comprehensive Tax Solutions */}
          <Grid item xs={12} sm={6}>
            <Card  sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG3} // You can replace with any image
                    alt="Tax Solutions"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      Comprehensive Tax Solutions
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Navigate taxation with ease through our expert consultation and return submissions. We handle corporate and personal taxes, including VAT and TIN registration, ensuring compliance.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Card 4: Business Registration */}
          <Grid item xs={12} sm={6}>
            <Card sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG4} // You can replace with any image
                    alt="Business Registration"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      Business Registration
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Streamline your business setup with our registration services for local and international markets. We ensure your business is registered efficiently and ready to operate.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Bottom-centered Contact Button */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 4,
        }}
      >
        <Button
          component={Link}
          to="/global/contact-us"
          sx={{
            width: '150px',
            color: 'white',
            backgroundColor: '#001f3f',
            borderRadius: '20px',
            padding: '2px',
            fontSize: '20px',
            fontWeight: '700',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#434343',
            },
          }}
        >
          See more
        </Button>
      </Box>
    </Box>
  );
}
